<script>
import { Bar } from 'vue-chartjs';

export default {
	extends: Bar,
	props: {
		chartData: {
			type: Array,
			default: () => {}
		},
		chartData2: {
			type: Array,
			default: () => {}
		},
		labels: {
			type: Array,
			default: () => {}
		},
		categoryLabels: {
			type: Array,
			default: () => {}
		},
		colors: {
			type: Array,
			default: () => {}
		}
	},
	data: () => ({
		data: {
			options: {
				scales: {
					yAxes: [
						{
							scaleLabel: {
								display: true,
								labelString: 'Händelser',
								fontSize: 16
							},
							ticks: {
								beginAtZero: true
							},
							labelString: 'Rapporterade',
							gridLines: {
								display: true
							},
							stacked: true
						}
					],
					xAxes: [
						{
							ticks: {
								beginAtZero: true
							},
							gridLines: {
								display: false
							},
							stacked: true
						}
					]
				},
				legend: {
					display: false
				},
				responsive: true,
				maintainAspectRatio: false,
				height: 200
			},
			chartData: {
				datasets: [
					{
						label: 'Ett',
						data: [67.8],
						backgroundColor: '#D6E9C6'
					},
					{
						label: 'Två',
						data: [20.7],
						backgroundColor: '#FAEBCC'
					}
				]
			}
		}
	}),
	watch: {
		chartData: function() {
			this.data.chartData.datasets[0].data = this.chartData;
			this.data.chartData.datasets[1].data = this.chartData2;
			this.$data._chart.update();
		}
	},
	mounted() {
		this.data.chartData.datasets[0].data = this.chartData;
		this.data.chartData.datasets[1].data = this.chartData2;
		this.data.chartData.datasets[0].backgroundColor = this.colors[0];
		this.data.chartData.datasets[1].backgroundColor = this.colors[1];
		this.data.chartData.datasets[0].label = this.categoryLabels[0];
		this.data.chartData.datasets[1].label = this.categoryLabels[1];
		this.data.chartData.datasets[0].hoverBackgroundColor = this.colors[0];
		this.data.chartData.datasets[1].hoverBackgroundColor = this.colors[1];
		this.data.chartData.datasets[0].hoverBorderColor = this.colors[0];
		this.data.chartData.datasets[1].hoverBorderColor = this.colors[1];
		this.data.chartData.labels = this.labels;
		this.$nextTick(() => {
			this.renderChart(this.data.chartData, this.data.options);
		});
	}
};
</script>

<style>
.chartjs-render-monitor {
  max-width: 100%;
}
</style>
